document.helixConfig = {
    apiBaseUrl: 'https://app.gleen.ai',
    company: 'puffy_canada',
    userMetadata: {
        country: 'CA',
    },
};
var isChatWidgetLoaded = false;  
var gleenChat;
(function() {
    var f = document.createElement('link');
    f.setAttribute('rel', 'stylesheet');
    f.setAttribute('href', 'https://fonts.googleapis.com/css2?family=Nunito&family=Plus+Jakarta+Sans:ital,wght@0,700;1,600&display=swap');
    document.head.appendChild(f);
    var d = document.createElement('div')
    d.setAttribute('id', 'helix-chat-container');
    const index = !!document.querySelector('[data-template="index"]');
    var classes = `chat-icon-section ${ index ? 'chat-icon-section--home' : '' }`
    d.setAttribute('class', classes)
    const sharePage = document.querySelector('[data-template="page.talkable"]')
    if (sharePage) {
        d.classList.add('chat-icon-section--shown')
    }
    document.body.appendChild(d);
    var s = document.createElement( 'script' );
    s.setAttribute('src', 'https://app.gleen.ai/sdk/gleenWidget.js');
    s.onload = function(){
        gleenChat = new GleenChat(document)
    }
    document.body.appendChild(s);
}());
  
class GleenChat {
    constructor(document) {
        this.document = document
        this.chatIcon = this.document.querySelector('#helix-chat-container')
        this.chatOpeners = this.document.querySelectorAll('.jsOpenGorgias , .jsOpenFreshchat')
        console.log("🚀 ~ file: gleenAI-script.js:29 ~ GleenChat ~ constructor ~ this.chatOpeners :", this.chatOpeners )
        this.firstVisit = localStorage.getItem('gorgiasFirstVisit')
        this.open = this.open.bind(this)
        this.open()
    }
    open() {
        for (const GO of this.chatOpeners) {
        GO.addEventListener('click', (e) => {
            e.preventDefault()
            this.chatIcon.classList.add('chat-icon-section--shown')
            window.gleenWidget.open()
        })
        }
    }
}